<template>
  <div class="persons">
    <el-row justify="center">
      <el-col :span="14" align="center">
        <div class="persons-call mb-5">
          <div v-html="data.call"></div>
        </div>
      </el-col>
    </el-row>

    <el-row justify="center">
      <el-col :span="11" align="center">
        <el-row
          justify="center"
          class="ia green-box"
          @click="handleSelectedService('day')"
        >
          <el-col align="right" :span="12">
            <div class="ia-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../assets/icons/calendar.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="12">
            <el-col align="center">
              <div class="ia-title pt-2">Nosso Dia a Dia</div>
              <div class="ia-description pt-1">saiba mais</div>
            </el-col>
          </el-col>
        </el-row>
      </el-col>

      <el-col :span="11" align="center">
        <el-row
          justify="center"
          class="ia blue-box"
          @click="handleSelectedService('benefits')"
        >
          <el-col align="right" :span="12">
            <div class="ia-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../assets/icons/win.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="12">
            <el-col align="center">
              <div class="ia-title pt-2">Benefícios</div>
              <div class="ia-description pt-1">saiba mais</div>
            </el-col>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine mt-3">
      <el-col :span="22" align="center">
        <component
          :is="selectedService"
          @close-service="closeService"
          :data="data"
        ></component>
      </el-col>
    </el-row>

    <el-row justify="center" @click="openHomeOffice = !openHomeOffice">
      <el-col :span="22" align="center">
        <el-row justify="center" class="ia">
          <el-col align="right" :span="12">
            <div class="ia-image">
              <figure>
                <img
                  class="icon"
                  alt="Vue logo"
                  src="../../assets/icons/worker.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="12">
            <el-col align="center">
              <div class="ia-title pt-2">Sweet Home (Office)</div>
              <div class="ia-description pt-1">saiba mais</div>
            </el-col>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <home-office
      v-if="openHomeOffice"
      @close-service="closeService('home')"
      :data="data"
    ></home-office>
  </div>
</template>

<script>
import Card from '@/components/card/Card.vue'
import Day from './Day/Day.vue'
import Benefits from './Benefits/Benefits.vue'
import HomeOffice from './HomeOffice/HomeOffice.vue'
import { ref } from 'vue'
import axios from 'axios'
import { firebaseRoutes } from '../../config/firebase.conf'
export default {
  name: 'Persons',
  components: {
    Card,
    Day,
    Benefits,
    HomeOffice
  },
  async setup (props) {
    const openHomeOffice = ref(false)
    const selectedService = ref('')
    const data = ref('')
    data.value = await axios.get(firebaseRoutes.pessoas).then((response) => {
      const result = []
      for (const id in response.data) {
        result.push({
          id: id,
          call: response.data[id].call,
          day: response.data[id].day,
          dayFirstCall: response.data[id].dayFirstCall,
          dayFerias: response.data[id].dayFerias,
          daySecondCall: response.data[id].daySecondCall,
          imgFerias: response.data[id].imgFerias,
          bancoDeHoras: response.data[id].bancoDeHoras,
          acessoEmpresa: response.data[id].acessoEmpresa,
          objetivos: response.data[id].objetivos,
          carreira: response.data[id].carreira,
          cargos: response.data[id].cargos,
          meritos: response.data[id].meritos,
          beneficiosTexto: response.data[id].beneficiosTexto,
          imgSaude: response.data[id].imgSaude,
          imgConforto: response.data[id].imgConforto,
          imgReconhecimento: response.data[id].imgReconhecimento,
          imgFacilidades: response.data[id].imgFacilidades,
          homeOfficeTexto: response.data[id].homeOfficeTexto,
          remotoTexto: response.data[id].remotoTexto,
          clientesTexto: response.data[id].clientesTexto,
          videoTexto: response.data[id].videoTexto
        })
      }
      return result[0]
    })

    const closeService = (home) => {
      if (home) {
        openHomeOffice.value = false
        return
      }
      selectedService.value = ''
    }

    const handleSelectedService = (service) => {
      if (service === 'day') {
        selectedService.value === 'day' ? selectedService.value = '' : selectedService.value = 'day'
        return
      }
      selectedService.value === 'benefits' ? selectedService.value = '' : selectedService.value = 'benefits'
    }
    return {
      data,
      selectedService,
      openHomeOffice,
      closeService,
      handleSelectedService
    }
  }
}
</script>

<style lang="scss" >
@import "~@/styles/variables.scss";
.persons-titles {
  text-transform: uppercase;

  h3 {
    font-weight: bold;
    color: $green;
    max-width: 60%;
    font-size: 3rem;
    line-height: 4rem;
    margin-bottom: 5rem;
  }

  h4 {
    font-size: 3rem;
    line-height: 4rem;
    color: $green;
    font-weight: 300;
  }

  h5 {
    font-weight: bold;
    font-size: 1.8rem;

    line-height: 4rem;
    color: $green;
    font-weight: 300;
  }

  p {
    padding-top: 2rem;
    text-transform: none;
    width: 60%;
  }
}
</style>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.persons {
  em {
    color: $light-blue;
    display: inline;
    font-size: 1.6rem;
    font-weight: normal;
  }
}

.persons-call {
  max-width: 98rem;
  em {
    color: $light-blue;
    display: inline;
    font-size: 1.6rem;
    font-weight: normal;
  }
}
.ia {
  cursor: pointer;
  background-color: $purple;
  color: $white;
  padding: 2rem;
  margin: 0.8rem;
}

.ia-image {
  padding-right: 6rem;

  img {
    height: 7.5rem;
  }
}

.ia-title {
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;
}

.ia-description {
  font-size: 1.4rem;
  text-transform: uppercase;
}

.green-box {
  background-color: $green;
}

.blue-box {
  background-color: $light-blue;
}
.last {
  margin-bottom: 20rem;
}
</style>
